module.exports = __webpack_public_path__ + "img/pencil.c6de5db4.svg";